module.exports = __webpack_public_path__ + "static/img/14.55ecca5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/14.png
// module id = 3ftt
// module chunks = 0